export default __webpack_public_path__ + "static/media/tejas.cc56908a.jpeg";